export class MobileMenuBar {

    static toggleMobileMenu(newState : string = 'auto') : void {
        const buttonObj = $('.mobile-bars-header');
        const isShown = (
            newState === 'auto'
                ? !buttonObj.hasClass('glyphicon-delete')
                : newState === 'show'
        );

        $('body').toggleClass('o-hidden', isShown);
        buttonObj
        .toggleClass('glyphicon-hm', !isShown)
        .toggleClass('glyphicon-delete', isShown);
        $('#mobileMenu').toggle(isShown);
    }

    static initMobileMenuBar() : void {
        $('.mobile-bars-header').on(
            'click.mobileHeaderClick',
            (event: JQuery.TriggeredEvent) => {
                event.preventDefault();
                MobileMenuBar.toggleMobileMenu();
            },
        );
    }

}
